<layout>
    <h1>Thanks for confirming your email</h1>
    <p>We're settings things up for you.  This could take several seconds</p>
</layout>